//#region import
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Radio, Typography } from '@mui/material';
import { TextBoxItem } from 'components/Input/TextBox';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { useLocation, useNavigate } from 'react-router';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import SwitchFormItem from 'components/Input/Switch';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { GetMenuPermission } from 'utilities/SystemFunction';

//#endregion

const UserSystemForm = () => {
    const navigate = useNavigate();
    const onBack = () => navigate("/UserSystemList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const [arrOrganization, setarrOrganization] = useState<any>([]);
    const [arrUserUnit, setarrUserUnit] = useState<any>([]);
    const [arrUserTitle, setarrUserTitle] = useState<any>([]);

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const onSubmit = () => {

        let param = {
            sID: sID ? sID : "",
            sFName: form.getValues("sFName"),
            sLName: form.getValues("sLName"),
            sEmail: form.getValues("sEmail"),
            sTelNo: form.getValues("sTelNo"),
            nTitleID: form.getValues("nTitleID"),
            isActive: form.getValues("isActive"),
            nUnitTypeID: form.getValues("nUnitTypeID"),
            nUnitID: form.getValues("nUnitID"),
        };
        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`UserSystem/SaveUserSystem`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate(`/UserSystemList`);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const GetGroupRoleEdit = () => {
        let param = {
            sID: sID ? sID : ""
        };
        setLoadingTable(true);
        AxiosFn.Post(`UserSystem/GetUserSystemEdit`, param, (result) => {
            if (sID) {
                form.setValue("sFName", result.sFName);
                form.setValue("sLName", result.sLName);
                form.setValue("sEmail", result.sEmail);
                form.setValue("nTitleID", result.nTitleID);
                form.setValue("sTelNo", result.sTelNo);
                form.setValue("nUnitTypeID", result.nUnitTypeID);
                form.setValue("nUnitID", result.nUnitID);
                form.setValue("isActive", result.isActive);
                setDataRow({
                    ...dataRow,
                    arrRows: result.lstProject ?? [],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
                setLoadingTable(false);
            }
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };


    const getFormInitial = () => {
        AxiosFn.Get(`UserSystem/GetFormInitial`, {}, (result) => {
            setarrOrganization(result.lstUnitMaster);
            setarrUserUnit(result.lstUnit);
            setarrUserTitle(result.lstUserTitle);
        })
    }


    const dataColumn: any = [
        {
            field: "sYear",
            headerName: "ปี",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 100,
            disableColumnMenu: true,
        },
        {
            field: "sProjectName",
            headerName: "ชื่อโครงการ",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 250,
            disableColumnMenu: true,

        },

    ];

    useEffect(() => {
        getFormInitial();
        if (sID != "") {
            form.setValue("isActive", true);
            GetGroupRoleEdit();
        }
    }, [])

    return (
        <>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                        <SelectItem
                            id="nTitleID"
                            name={"nTitleID"}
                            label={"คำนำหน้า"}
                            placeholder={"คำนำหน้า"}
                            options={arrUserTitle}
                            required={true}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <TextBoxItem
                            name="sFName"
                            label='ชื่อ'
                            maxLength={100}
                            id={"sFName"}
                            required={true}
                            type={'text'}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <TextBoxItem
                            name="sLName"
                            label='นามสกุล'
                            maxLength={100}
                            id={"sLName"}
                            required={true}
                            type={'text'}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SelectItem
                            id="nUnitTypeID"
                            name={"nUnitTypeID"}
                            label={"ประเภทหน่วยงาน"}
                            placeholder={"ประเภทหน่วยงาน"}
                            options={arrOrganization}
                            required={true}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SelectItem
                            id="nUnitID"
                            name={"nUnitID"}
                            label={"ชื่อหน่วยงาน"}
                            placeholder={"ชื่อหน่วยงาน"}
                            options={arrUserUnit}
                            required={false}
                            disabled={true}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("email")}`}
                            id={'sEmail'}
                            name={'sEmail'}
                            maxLength={100}
                            type={'email'}
                            IsShowMessageError={true}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextBoxItem
                            name="sTelNo"
                            label='เบอร์โทรศัพท์'
                            maxLength={20}
                            id={"sTelNo"}
                            required={false}
                            type={'text'}
                            isTelNo={true}
                            disabled={!isPermission}
                            IsShowMessageError={true}
                            pattern={'en-number'}
                        />
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Typography>
                            ข้อมูลโครงการขอรับเงินสนับสนุน
                        </Typography>
                        <Divider />
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <DataGrid
                            isLoading={loadingTable}
                            columns={dataColumn}
                            rows={dataRow}
                            isHiddenToolHead={true}
                            isHiddenFooter={true}
                            isShowCheckBox={false}
                        />
                    </Grid>


                    <Grid item xs={12} md={12}>
                        <Typography>
                            สถานะ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SwitchFormItem
                            name={"isActive"}
                            checkText='ใช้งาน'
                            uncheckText='ไม่ใช้งาน'
                            width={130}
                            id={"isActive"}
                            disabled={!isPermission}
                        />
                    </Grid>
                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>

            </FormProvider >
        </>
    )
}
export default UserSystemForm;
